.sheet {
  position: fixed;
  inset: auto 0 0 0;
  width: 100%;
  max-width: 100%;
  max-height: 85dvh;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 16px 16px 0 0;
  background: var(--surface);
  color: var(--text);
  box-shadow: var(--shadow-pop);
  overflow-y: auto;
}

.sheet::backdrop {
  background: var(--overlay);
}

.content {
  padding: 16px var(--gutter) calc(16px + env(safe-area-inset-bottom));
}
